import React, { Component } from "react";
import CustomButton from "../components/CustomButton";
import { Icon } from "@iconify/react";
import newLabelOutlineRounded from "@iconify/icons-material-symbols/new-label-outline-rounded";
import labelRounded from "@iconify/icons-material-symbols/label-rounded";
import baselineCheckCircle from "@iconify/icons-ic/baseline-check-circle";
import { Form } from "react-bootstrap";

export default class PrinterItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelValue: this.props.item.label ? this.props.item.label : "",
      editedMode: false,
    };
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div
        // style={{ backgroundColor: "red", width: "100%" }}
        className="UGItem"
        style={{
          backgroundColor: this.props.item.selected ? "var(--brown1)" : "white",
          marginRight: "0px",
          border: "1px solid var(--gray3)",
          fontSize: "14px",
          color: "var(--black1)",
          lineHieght: "25px",
          padding: "5px",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          alignItems: "flex-start",
          // justifyContent: "flex-start",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: "0px",
            top: "0px",
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
          }}
          onClick={() => {
            if (!this.state.editedMode)
              this.props.changeSelect(this.props.item.title);
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            alignItems: "center",
          }}
        >
          {!this.state.editedMode && <div>{this.props.item.title}</div>}

          {!this.state.editedMode && (
            <Icon
              icon={
                this.props.item.label ? labelRounded : newLabelOutlineRounded
              }
              style={{ fontSize: "20px", cursor: "pointer", zIndex: "1" }}
              onClick={() => {
                this.setState({ editedMode: true });
              }}
            />
          )}

          {this.state.editedMode && (
            <Form.Control
              className="inputStyleForm printerLabelStyle"
              style={{
                maxWidth: "100px",
                direction: "ltr",
                fontSize: "12px",
                zIndex: "1",
              }}
              placeholder="عنوان"
              type="text"
              name="labelValue"
              onChange={this.textHandleChange.bind(this)}
              value={this.state.labelValue}
            />
          )}

          {this.state.editedMode && (
            <Icon
              icon={baselineCheckCircle}
              style={{ fontSize: "20px", cursor: "pointer", zIndex: "1" }}
              onClick={() => {
                this.props.changeLabel(
                  this.props.item.title,
                  this.state.labelValue
                );
                this.setState({ editedMode: false });
              }}
            />
          )}
        </div>
        {!this.state.editedMode && (
          <div style={{ fontSize: "10px", color: "var(--black2)" }}>
            {this.props.item.label}
          </div>
        )}

        {!this.state.editedMode && this.props.item.selected && (
          <Form.Check
            className="printerCheckbox"
            type="checkbox"
            checked={this.props.item.forCashier}
            readOnly
            label="صندوق‌دار"
            onChange={(e) => {
              if (e) this.props.setForCashier(this.props.item.title);
            }}
            style={{
              fontSize: "12px",
              marginRight: "16px",
            }}
          />
        )}
      </div>
    );
  }
}
